// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3062) return "static/chunks/walletconnect-8ea7579abaf81bf8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"528":"f1a02c26a3e57ce2","1616":"8b96d79513402bf1","2519":"15e797db725d7c80","3649":"df93ce3182454fb4","5969":"8941e39c0d8f5f61","8468":"98388882d921cdcd","8767":"3d6580453824bfcc"}[chunkId] + ".js";
};